import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SkeletonDirective } from '../skeleton-loader/skeleton-directive';

@Component({
  selector: 'tt-guideline-preview-card-placeholder',
  standalone: true,
  imports: [SkeletonDirective],
  template: `
    <div class="card">
      <div class="heading">
        <ng-container *skeleton="true; height: '20px'" class="title" />
        <ng-container *skeleton="true; height: '14px'; width: '140px'" class="secondary-text" />
      </div>
      <div class="footer">
        <ng-container *skeleton="true; height: '16px'; width: '80px'" class="secondary-text" />
        <ng-container *skeleton="true; height: '40px'; width: '100px'" class="secondary-text" />
      </div>
    </div>
  `,
  styleUrls: ['./guideline-preview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidelinePreviewCardPlaceholderComponent {}
